document.addEventListener('teeinblue-event-component-injected', function() {
    const formContainer = document.querySelector('#teeFormInputs');
    if(!formContainer) return;

    /* ====== Function toggle recustomize button ====== */
    function toggleRecustomizeButtons() {
        const photoFields = formContainer.querySelectorAll('.tee-field--photo');
        if(photoFields.length > 0) {
            photoFields.forEach(field => {
                const hasImage = !!field.querySelector('.tee-photo-image');
                const recustomizeBtn = field.querySelector('.tee-btn--recustomize');
                if (recustomizeBtn) {
                    recustomizeBtn.style.display = hasImage ? '' : 'none';
                }
            });
        }
    }

    /* ====== MutationObserver DOM ====== */
    const observer = new MutationObserver(() => {
        toggleRecustomizeButtons();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    /* ====== Patch fetch with cart/add.js only ====== */
    const originalFetch = window.fetch;
    window.fetch = async function(input, init) {
        if (typeof input === "string" && input.includes("/cart.js")) {
            const response = await originalFetch.apply(this, arguments);

            try {
                const clone = response.clone();
                clone.json().then(data => {
                    const buttons = document.querySelectorAll('#teeFormInputs .tee-photo-clear');
                    if (buttons.length) {
                        buttons.forEach(btn => btn.click());
                    }
                    setTimeout(() => {
                        if(window.teeinblue) window.teeinblue.resetCustomization(window.teeinblueCampaign.productId);
                    }, 1000)
                    

                    toggleRecustomizeButtons();
                });
            } catch (e) {
                console.warn("[Intercept] Response not JSON:", e);
            }

            return response;
        }

        return originalFetch.apply(this, arguments);
    };

    toggleRecustomizeButtons();

    function renderCustomizationImage() {
        fetch("/cart.js")
        .then(response => response.json())
        .then(data => {
            const items = data.items;
            const cartProducts = document.querySelectorAll(".slidecarthq .item");

            items.forEach((item, index) => {
                if (item.properties && item.properties._customization_image) {
                    const imageUrl = item.properties._customization_image;
                    const cartProduct = cartProducts[index];
                    if (cartProduct) {
                        const imageElement = cartProduct.querySelector(".item-image-anchor img");
                        if (imageElement) {
                            imageElement.src = imageUrl;
                        }
                        
                    }
                }
            });
        }).catch(error => console.error("Error fetch cart.js:", error));
    }

    function updateCartImages() {
        fetch("/cart.js")
        .then((response) => response.json())
        .then((data) => {
            const items = data.items;
            const cartItems = document.querySelectorAll(".slidecarthq .item");
            if(cartItems.length > 0) {
                items.forEach((item) => {
                    if (item.properties && item.properties._customization_image) {
                        const imageUrl = item.properties._customization_image;
                        const cartItem = document.querySelector(`.slidecarthq .item[data-line-item-key="${item.key}"]`);

                        if (cartItem) {
                            const imageContainer = cartItem.querySelector(".item-image-anchor img");
                            if (imageContainer && imageContainer.src !== imageUrl) {
                                imageContainer.src = imageUrl;
                            }
                        }
                    }
                });
            }
        })
        .catch((error) => {
            console.error("Error fetch cart.js:", error);
        })
    }

    window.SLIDECART_ADDED_TO_CART = function name(params) {
        const buttons = document.querySelectorAll('#teeFormInputs .tee-photo-clear');
        if (buttons.length) {
            buttons.forEach(btn => btn.click());
        }
        setTimeout(() => {
            if(window.teeinblue) window.teeinblue.resetCustomization(window.teeinblueCampaign.productId);

            updateCartImages();
        }, 1000)
    }

    window.SLIDECART_OPENED = function name(params) {
        updateCartImages();
    }
})